var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-summary"},[_c('div',{staticClass:"mb-4 subtitle-1 font-italic"},[_vm._v("Select a location to add to cart")]),_c('add-to-cart-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }